// read_more_controller.js
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['content', 'button'];
    static values = {
        maxHeight: { type: Number, default: 300 },
        moreText: { type: String, default: 'Skaityti plačiau' },
        lessText: { type: String, default: 'Skaityti mažiau' },
    };

    connect() {
        this.checkOverflow();
        // Recheck on window resize
        this.resizeObserver = new ResizeObserver(() => this.checkOverflow());
        this.resizeObserver.observe(this.contentTarget);
    }

    disconnect() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }

    checkOverflow() {
        const content = this.contentTarget;
        const fullHeight = content.scrollHeight;

        // If content doesn't overflow, hide the button
        if (fullHeight <= this.maxHeightValue) {
            this.buttonTarget.hidden = true;
            content.style.maxHeight = 'none';
            content.classList.remove('-truncated');
            return;
        }

        // Content overflows, show button and truncate
        this.buttonTarget.hidden = false;
        if (!content.classList.contains('-expanded')) {
            content.style.maxHeight = `${this.maxHeightValue}px`;
            content.classList.add('-truncated');
        }
    }

    toggle() {
        const content = this.contentTarget;
        const button = this.buttonTarget;
        const isExpanded = content.classList.contains('-expanded');

        button.classList.toggle('btn-plus', isExpanded);
        button.classList.toggle('btn-minus', !isExpanded);

        if (isExpanded) {
            // Collapse
            content.style.maxHeight = `${this.maxHeightValue}px`;
            content.classList.remove('-expanded');
            content.classList.add('-truncated');
            button.textContent = this.moreTextValue;
            button.setAttribute('aria-expanded', 'false');
        } else {
            // Expand
            content.style.maxHeight = `${content.scrollHeight}px`;
            content.classList.add('-expanded');
            content.classList.remove('-truncated');
            button.textContent = this.lessTextValue;
            button.setAttribute('aria-expanded', 'true');
        }
    }
}
